import * as React from "react"
import LatestNews from "@components/LatestNews"

const StrapiRelatedNews = ({
    title,
    overline,
    relatedArticles = null
}: GatsbyTypes.LatestNewsFragment & {
    relatedArticles: any
}) => {
    if (!relatedArticles) {
        return null
    }

    return <LatestNews
        subtitle={overline || ""}
        title={title || ""}
        items={relatedArticles}
    />
}

export default StrapiRelatedNews
